import { apiService } from '../../..'
import { CreditLimitResponse, DecreaseConsumerLendingCreditLimitRequest, ConsumerLendingDecreaseCreditLimitOptionsResponse } from '../types'

export const creditLimitService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getCreditLimit: build.query<CreditLimitResponse, void>({
      query: () => {
        return {
          url: '/portal/consumers/limit',
          method: 'GET',
        }
      },
      providesTags: ['CreditLimit'],
    }),
    getConsumerLendingCreditLimit: build.query<CreditLimitResponse, void>({
      query: () => {
        return {
          url: '/portal/consumers/lending/limit',
          method: 'GET',
        }
      },
      providesTags: ['CreditLimit'],
    }),
    getConsumerLendingDecreaseCreditLimitOptions: build.query<ConsumerLendingDecreaseCreditLimitOptionsResponse, void>({
      query: () => {
        return {
          url: '/portal/consumers/account/facility/limit-decrease',
          method: 'GET',
        }
      },
      providesTags: ['CreditLimit'],
    }),
    decreaseConsumerLendingCreditLimit: build.mutation<void, DecreaseConsumerLendingCreditLimitRequest>({
      query: (req) => {
        return {
          url: '/portal/consumers/account/facility/limit-decrease',
          method: 'POST',
          data: req,
        }
      },
      invalidatesTags: ['CreditLimit', 'CreditFacility', 'CreditFacilitySummary'],
    }),
  }),
})
